import { render, staticRenderFns } from "./SpeedDialFab.vue?vue&type=template&id=2bef5e27&scoped=true&"
import script from "./SpeedDialFab.vue?vue&type=script&lang=js&"
export * from "./SpeedDialFab.vue?vue&type=script&lang=js&"
import style0 from "./SpeedDialFab.vue?vue&type=style&index=0&id=2bef5e27&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bef5e27",
  null
  
)

export default component.exports